import {StartupResource} from '@services/resource/startup-resource';
import {ImageResource} from '@services/resource/image-resource';
import {StartupLinkResource} from '@services/resource/startup-link-resource';
import {LinkType} from '@services/resource/link-type';
import moment, {Moment} from 'moment';
import {ContactResource} from '@services/resource/contact-resource';

export class Startup {
  constructor(
    public readonly uuid: string,
    public readonly name: string,
    public readonly nickname: string,
    public readonly zip: string | undefined,
    public readonly city: string | undefined,
    public readonly street: string | undefined,
    public readonly phone: string | undefined,
    public readonly countryIso2Code: string | undefined,
    public readonly countryPhoneCode: string | undefined,
    public readonly logo: ImageResource | undefined,
    public readonly description: string,
    public readonly founded: string,
    public readonly productGroup: string,
    public readonly links: StartupLinkResource[],
    public readonly created: Moment | undefined,
    public readonly createdByMnet: string | undefined,
    public readonly contact: ContactResource,
  ) {}

  public static fromResource(r: StartupResource) {
    return new Startup(
      r.uuid,
      r.name,
      r.nickname,
      r.zip,
      r.city,
      r.street,
      r.phone,
      r.countryIso2Code,
      r.countryPhoneCode,
      r.logo,
      r.description,
      r.founded,
      r.productGroup,
      r.links,
      moment(r.created),
      r.createdByMnet,
      r.contact,
    );
  }

  public static extractLink(linkType: LinkType, links: StartupLinkResource[]): string {
    const startupLinkResource = links ? links.find((a) => a.type === linkType) : undefined;
    return startupLinkResource ? startupLinkResource.link : '';
  }
}
